
const feishuApi = function(api, data) {
    return new Promise((resolve, reject) => {
        window.tt[api]({  //获取临时登录code
            ...data,
            success: (info) => {
                resolve(info);
            },
            fail: (error) => {
                console.log(error)
            }
        });
    })
    
}

export default feishuApi;


// WEBPACK FOOTER //
// ./src/feishu/api.js